import { Alert, Button, Card, ColorSchemeSwitch } from '../shared/components';

import styles from './AuthPages.module.css';

/**
 * Sign-in. Route composition only — no business rules, no platform access
 * (blueprint §3.1, §5.4).
 */
export interface SignInPageProps {
  readonly onSignIn: () => void;
  readonly busy: boolean;
  readonly errorAr: string | null;
}

export function SignInPage({ onSignIn, busy, errorAr }: SignInPageProps) {
  return (
    <div className={styles.page}>
      <div className={styles.schemeSlot}>
        <ColorSchemeSwitch />
      </div>

      <Card>
        <div className={styles.brand}>
          <span className={styles.mark}>
            <img
              src="/logo-png-pic.png"
              alt="مدارس الرشيد الحديثة"
              className={styles.logo}
            />
          </span>
          <h1 className={styles.title}>صندوق التأمين الصحي</h1>
          <p className={styles.subtitle}>مدارس الرشيد الحديثة</p>
        </div>

        {errorAr ? <Alert severity="error">{errorAr}</Alert> : null}

        <p className={styles.body}>
          سجّل الدخول بحساب المدرسة الرسمي لتعبئة بياناتك ورفع وثائقك.
        </p>

        <Button size="lg" fullWidth loading={busy} onClick={onSignIn}>
          الدخول بحساب المدرسة
        </Button>

        <p className={styles.note}>
          الدخول مقتصر على حسابات ‎@rasheed.school‎ الرسمية.
        </p>
      </Card>
    </div>
  );
}
